import { render, staticRenderFns } from "./protocol_item.vue?vue&type=template&id=7852c422"
import script from "./protocol_item.vue?vue&type=script&lang=js"
export * from "./protocol_item.vue?vue&type=script&lang=js"
import style0 from "./protocol_item.vue?vue&type=style&index=0&id=7852c422&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports